module.exports = __webpack_public_path__ + "img/metal_j@2x.fe774b2d.png";